import { isValid, format as fnsFormat, parse as parseFns } from 'date-fns';

import * as Locales from 'date-fns/esm/locale';

/**
 * ð±ð¹ ð³ð´ ðªðº Locales
 * If something wrong with dates - check locales import,
 * if there is such a language
 * and its name is correct
 */

const getCurrentUserLanguage = () => {
  const { userLanguage, language } = window.navigator;

  if (language) {
    /**
     * We are selecting first language from the list, because it's means
     * that is users native or prefered language/locale
     */
    if (language === 'en') {
      return 'enUS';
    }

    if (
      ['en-GB', 'en-US', 'en-US'].indexOf(language) === -1 &&
      language.indexOf('-') > -1
    ) {
      return language.split('-')[0];
    }

    return language.replace('-', '');
  } else {
    return userLanguage.replace('-', '');
  }
};

export const format = (date, format) => {
  if (!isValid(new Date(Date.parse(date)))) {
    return '-';
  }

  const locale = Locales[getCurrentUserLanguage()];

  const options = {};

  if (locale) {
    options.locale = locale;
  }

  return fnsFormat(parse(date).getTime(), format, options);
};

export const formatLocal = (date, format) => {
  if (!isValid(new Date(Date.parse(date)))) {
    return '-';
  }

  const locale = Locales[getCurrentUserLanguage()];

  const options = {};

  if (locale) {
    options.locale = locale;
  }

  return fnsFormat(parseWithTimeZone(date).getTime(), format, options);
};

export const parseLocal = date => {
  const locale = Locales[getCurrentUserLanguage()];

  return parseFns(
    date,
    locale.formatLong.date({
      width: 'short'
    }),
    new Date(2010, 0, 1),
    {
      locale
    }
  );
};

export const parse = date => {
  if (!isValid(new Date(Date.parse(date)))) {
    return '-';
  }

  // Hack, replace +00:00 or any time zone to nothing.
  const dateWithoutTimeZone =
    typeof date === 'string'
      ? date.replace(new RegExp(/\+\d\d:\d\d/), '').replace('Z', '')
      : date;

  return new Date(Date.parse(dateWithoutTimeZone));
};

export const parseWithTimeZone = date => {
  if (!isValid(new Date(Date.parse(date)))) {
    return '-';
  }

  return new Date(Date.parse(date));
};
